// A ORDEM DAS INTEGRAÇÕES (Fase 3A, T19, 13/10/2026). A lista vinha na ordem
// do arquivo de apps herdado — Webhooks, OpenAI, Dialogflow e Dyte antes do
// Asaas —, e quem abria a tela para ligar a cobrança procurava o Asaas lá
// embaixo. Primeiro o que é do escritório; depois o resto, na ordem de sempre.
// O que pede atenção continua no topo (é o que o escritório tem de resolver).
export const DO_ESCRITORIO = ['asaas', 'tramitacao', 'telefonia', 'google'];

const posicao = item => {
  const i = DO_ESCRITORIO.indexOf(item.id);
  return i === -1 ? DO_ESCRITORIO.length : i;
};

export const ordemDasIntegracoes = lista =>
  lista
    .map((item, indice) => ({ item, indice }))
    .sort(
      (a, b) =>
        Number(Boolean(b.item.atencao)) - Number(Boolean(a.item.atencao)) ||
        posicao(a.item) - posicao(b.item) ||
        a.indice - b.indice
    )
    .map(({ item }) => item);
